export function formatShortDate(fecha?: string, fallback = 'Sin fecha'): string {
  if (!fecha) return fallback;

  const [anio, mes, dia] = fecha.split('-');
  if (!anio || !mes || !dia) return fecha;

  return `${dia}/${mes}/${anio}`;
}

export function formatNotificationDate(fecha?: string): string {
  if (!fecha) return 'Sin fecha';

  if (!fecha.includes('T') && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    const [anio, mes, dia] = fecha.split('-');
    return `${dia}/${mes}/${anio} 00:00:00 hrs`;
  }

  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return fecha;

  const pad = (n: number) => n.toString().padStart(2, '0');
  const dia = pad(d.getDate());
  const mes = pad(d.getMonth() + 1);
  const anio = d.getFullYear();
  const hora = pad(d.getHours());
  const min = pad(d.getMinutes());
  const seg = pad(d.getSeconds());

  return `${dia}/${mes}/${anio} ${hora}:${min}:${seg} hrs`;
}

